<template>
    <div class="sourceMaterial" v-if="!previewImg" :class="!isSelected ? 'cursor' : ''">
        <el-image v-if="type == 1" :src="src" class="elImage">
            <div slot="error" class="error">素材地址异常</div>
        </el-image>
        <div v-else-if="type == 2" class="videoBox" @click="preview(src, type)">
            <i class="el-icon-video-play play" v-if="!isSelected"></i>
            <video class="MaterialVideo" :src="src"></video>
        </div>
        <el-image v-else style="cursor: auto" class="elImage">
            <div slot="error" class="error">素材不存在</div>
        </el-image>
    </div>
    <div class="sourceMaterialImg" :class="!isSelected ? 'cursor' : ''" @click="preview(src, type)" v-else>
        <i class="el-icon-video-play play" v-if="!isSelected && type == 2"></i>
        <el-image :src="previewImg" class="elImage">
            <div slot="error" class="error">素材地址异常</div>
        </el-image>
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            default: '',
        },
        previewImg: {
            type: String,
            default: '',
        },
        isSelected: Boolean,
    },
    computed: {
        type() {
            console.log("this.src",this.src)
            if (!this.src) return 0;
            let flag = this.src.toLowerCase().endsWith('mp4');
            if (flag) {
                return 2;
            } else {
                return 1;
            }
        },
    },
    data() {
        return {};
    },
    methods: {
        // // 文件预览
        // preview(url, type) {
        //     if (this.isSelected) return;
        //     if (type == 1) {
        //         let images = url;
        //         this.$viewerApi({
        //             zIndex: 99999,
        //             images,
        //         });
        //     } else {
        //         this.$videoPreview({ type: type, fileUrl: url });
        //     }
        // },
    },
};
</script>

<style lang="less" scoped>
.sourceMaterial {
    overflow: hidden;
    display: inline-block;
    .videoBox {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        .MaterialVideo {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }
}
.sourceMaterialImg {
    overflow: hidden;
    display: inline-block;
    position: relative;
}
/deep/.error {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.072917rem;
    color: #c0c4cc;
    height: 100%;
    vertical-align: middle;
    background: #f5f7fa;
    overflow: hidden;
}

.play {
    position: absolute;
    z-index: 1;
    font-size: 32px;
    color: #ffffff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.elImage {
    width: 100%;
    height: 100%;
}
</style>
